












import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "UnsendConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    paid: { type: Boolean, default: false },
  },
});
